export class Roles {
  static USER_ADHERENT ='USER_ADHERENT';
  static USER_AGRIAL ='USER_AGRIAL';
}
